<template>
  <fichar :conIncidencia="true" textButtonFichar="Fichar con incidencia" bgColor="lime darken-3"></fichar>
</template>
<script>
import fichar from "@/components/fichajes/fichar";

export default {
  components: {
    fichar
  }
};
</script>
